export default "__VITE_ASSET__6xaesBwY__"